// Minimal client-side CSV export helpers.

function escapeCell(value) {
  if (value === null || value === undefined) return '';
  let s = Array.isArray(value) ? value.join('; ') : String(value);
  if (/[",\n]/.test(s)) {
    s = '"' + s.replace(/"/g, '""') + '"';
  }
  return s;
}

/**
 * Build a CSV string from an array of header keys and an array of row objects.
 * headers: [{ key, label }]  rows: [{ key: value }]
 */
export function toCsv(headers, rows) {
  const head = headers.map((h) => escapeCell(h.label)).join(',');
  const body = rows.map((row) => headers.map((h) => escapeCell(row[h.key])).join(',')).join('\n');
  return head + '\n' + body;
}

/** Trigger a download of CSV content in the browser. */
export function downloadCsv(filename, headers, rows) {
  const csv = toCsv(headers, rows);
  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function slugifyName(name) {
  return (name || 'export').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40) || 'export';
}
